import { ColumnProps } from './interface';

export default {
  name: 'ATableColumn',
  props: ColumnProps
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/table/Column.js
// module id = 743
// module chunks = 0